import React, {useState} from 'react';
import {DskPageProvider} from './desktop-page.context';

export const DskPageService = ({children}: any) => {
    const [visible, setVisible] = useState(true);

    const toggleVisible = () => {
        setVisible(!visible);
    };

    const show = () => {
        setVisible(true);
    };

    const hide = () => {
        setVisible(false);
    };

    return <DskPageProvider value={{visible, toggleVisible, show, hide}}>
        {children}
    </DskPageProvider>;
};
